import React from 'react'
import { animateScroll as scroll } from 'react-scroll'
import './style.css'

const Scrollbar = () => {
    const scrollToTop = () => {
        scroll.scrollToTop({
            duration: 500,
            smooth: true
        })
    }

    return (
        <div className="col-lg-12">
            <div className="header-menu">
                <ul className="smothscroll">
                    <li>
                        <a href="#!" onClick={scrollToTop}>
                            <i className="ti-arrow-up"></i>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default Scrollbar